import {
    UiStack,
    UiSuspensefulOutlet,
} from '@experiences/ui-common';
import React from 'react';

import { CodedDashboardsProvider } from './subcomponents/dashboards/hooks/useCodedDashboards';
import GovernanceV2LeftNav from './subcomponents/leftNav/GovernanceV2LeftNav';

const GovernanceV2PageComponent: React.FC = () => (
    <CodedDashboardsProvider>
        <UiStack
            direction="row"
            h="100%"
            w="100%"
            // Keep the row pinned to the viewport and let the content pane own the scroll
            // (below), so the left nav stays full-height and its divider never stops short
            // partway down a long, scrollable page.
            style={{
                overflow: 'hidden',
                minHeight: 0,
            }}
        >
            <GovernanceV2LeftNav />
            <UiStack
                direction="column"
                flex={1}
                // minHeight:0 lets this flex child shrink to the row height so its own
                // overflow scrolls internally instead of growing the row.
                style={{
                    overflowY: 'auto',
                    minHeight: 0,
                }}
            >
                <UiSuspensefulOutlet />
            </UiStack>
        </UiStack>
    </CodedDashboardsProvider>
);

export default GovernanceV2PageComponent;
